module.exports = __webpack_public_path__ + "img/add-photo-first-icon.53fec29a.svg";